import { Link } from "gatsby"
import styled from "styled-components"
export const TagWrapper = styled(Link)`
  display: inline-flex;
  place-items: center;
  text-align: center;
  height: 25px;
  width: auto;
  padding: 0 15px;
  margin-right: 10px;
  margin-top: 10px;
  background-color: #f6f6fb;
  border-radius: 15px;
  border: 1px solid #f6f6fb;
  &:hover {
    border: 1px solid #4c0ffb;
    cursor: pointer;
  }
`
TagWrapper.displayName = "TagWrapper"
export const ArticleTag = styled.div`
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme: { colors } }) => colors.accentBlue};
  cursor: pointer;
  z-index: 100;
`

ArticleTag.displayName = "ArticleTag"
